// extracted by mini-css-extract-plugin
export default {"BefaringInnkomneSide":"BefaringInnkomneSide-module__BefaringInnkomneSide__Byxph","InnkomneList":"BefaringInnkomneSide-module__InnkomneList__ehx-1"};